import React from "react";
import { Link, useLocation, useNavigate,} from "react-router-dom";
import './SideMenu.css';

   
export const SideMenuBar = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const DashboardisActive = location.pathname === '/Dashboard';
    const ListViewisActive = location.pathname === '/ListView';
    const CalendarPageisActive = location.pathname === '/CalendarPage';
    const PerformancePageisActive = location.pathname === '/PerformancePage';
    const UserControlisActive = location.pathname === '/UserControl';
    const SettingsPageisActive = location.pathname === '/SettingsPage';
    
    const DashboardbuttonStyle = {
      fontWeight: DashboardisActive ? 'bold' : 'normal',
      color: '#173452',
    };

    const ListViewbuttonStyle = {
      fontWeight: ListViewisActive ? 'bold' : 'normal',
      color: '#173452',
    };

    const CalendarPagebuttonStyle = {
      fontWeight: CalendarPageisActive ? 'bold' : 'normal',
      color: '#173452',
    }; 
    
    const PerformancePagebuttonStyle = {
      fontWeight: PerformancePageisActive ? 'bold' : 'normal',
      color: '#173452',
    };

    const UserControlbuttonStyle = {
      fontWeight: UserControlisActive ? 'bold' : 'normal',
      color: '#173452',
    };

    const SettingsPagebuttonStyle = {
      fontWeight: SettingsPageisActive ? 'bold' : 'normal',
      color: '#173452',
    };


    const handleDashboard = (event) => {
      event.preventDefault();
      navigate('/Dashboard');
  }

  const handleTask = (event) => {
      event.preventDefault();
      navigate('/ListView');
  }

  const handleCalendarPage = (event) => {
      event.preventDefault();
      navigate('/CalendarPage');
  }

  const handlePerformancePage = (event) => {
      event.preventDefault();
      navigate('/PerformancePage');
  }

  const handleUserControl = (event) => {
      event.preventDefault();
      navigate('/UserControl');
  }

  const handleUserSettingsPage = (event) => {
      event.preventDefault();
      navigate('/SettingsPage');
  }

  const handleLogout = () => {
    try {
        sessionStorage.removeItem('user');
        window.location.reload(true);
        window.location.href = '/SignIn'
    } catch (error) {
        console.error('Error removing user data from localStorage:', error);
    }
}
   
    return(
        <div className="sidebar2">
            <img className='logo_img' src="../assets/logo-no-background.png" alt="logo" height={"6%"}></img><br /><br />
            <button className='menu_btn1' style={DashboardbuttonStyle} onClick={handleDashboard}><img src="../assets/dashboard.png" alt="dashboard" className="dashboard" height={'25px'} style={{opacity:0.8}}/>           &nbsp;&nbsp;&nbsp;&nbsp;      <span className='menu_text1'> Dashboard  </span></button><br />
            <button className='menu_btn1' style={ListViewbuttonStyle}  onClick={handleTask}><img src="../assets/tasks.png" alt="tasks" className="tasks" height={'25px'} style={{opacity:0.7}}/>                             &nbsp;&nbsp;                  <span className='menu_text1'> Tasks      </span></button><br />
            <button className='menu_btn1' style={CalendarPagebuttonStyle} onClick={handleCalendarPage}><img src="../assets/calendar.png" alt="calendar" className="calendar" height={'24px'}/>                                  &nbsp;&nbsp;&nbsp;&nbsp;      <span className='menu_text1'> Calendar   </span></button><br />
            <button className='menu_btn1' style={PerformancePagebuttonStyle} onClick={handlePerformancePage}><img src="../assets/performance.png" alt="performance" className="performance" height={'25px'} style={{opacity:0.8}}/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className='menu_text1'> Performance</span></button><br />
            <button className='directory_menu_btn1'><img src="../assets/directory.png" alt="directory" className="directory" height={'30px'}/>                    &nbsp;&nbsp;&nbsp;            <span className='menu_text1'> Directory  </span>
            <div className="tooltip-content1">
                <Link to="/SiteDatabase">Site Database</Link><br/>
                <Link to='/EmployeeDatabase'>Employee Database</Link>
            </div>
            </button><br />    
            <button className='menu_btn1' style={UserControlbuttonStyle} onClick={handleUserControl}><img src="../assets/users.png" alt="users" className="users" height={'23px'}/>                                        &nbsp;&nbsp;&nbsp;&nbsp;<span className='menu_text1'> User Control</span></button><br /><br /><br /><br />
            <button className='menu_btn1' style={SettingsPagebuttonStyle} onClick={handleUserSettingsPage}><img src="../assets/setting.png" alt="setting" className="setting" height={'25px'} style={{opacity:0.8}}/>            &nbsp;&nbsp;&nbsp; <span className='menu_text1'> Setting     </span></button><br />
            <button className='menu_btn1' onClick={handleLogout}><img src="../assets/logout.png" alt="logout" className="logout" height={'30px'}/>                                                    &nbsp;&nbsp;           <span className='menu_text1'> Logout      </span></button><br />
    </div>     
    )
}

